import axios from "axios";
import app from "../_app";

const getStars = rating => {
    let stars = '';

    for(let i = 1; i <= 5; i ++) {

        let star = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="207 -707 546 519"><path d="m311-188 45-192-149-129 196-17 77-181 77 181 196 17-149 129 45 192-169-102-169 102Z"/></svg>';

        if(rating < i && Math.round(rating) === i) {
            star = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="207 -707 546 519"><path d="M480-635v312l126 77-33-144 111-96-146-13-58-136ZM311-188l45-192-149-129 196-17 77-181 77 181 196 17-149 129 45 192-169-102-169 102Z"/></svg>'

        } else if(i > rating) {
            star = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="1 2 20 18"><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/></svg>'
        }

        stars += `<i>${star}</i>`;
    }


    return stars;
};

const fetchReviews = async () => {
    const language = document.querySelector('html').getAttribute('lang');
    let response = await axios.get( `https://api.trustedshops.com/rest/public/v2/shops/${app.trustedShops[language]}/quality.json`);

    if (response.status === 200) {
        const score = response.data.response.data.shop.qualityIndicators.reviewIndicator.overallMark;
        const count = response.data.response.data.shop.qualityIndicators.reviewIndicator.totalReviewCount;
        const scoreWithComma = score.toString().replace('.', ',');
        const reviewsScoreElements = [...document.querySelectorAll('.js-footer-reviews-score')];
        const reviewsCountElements = [...document.querySelectorAll('.js-footer-reviews-count')];
        const stars = [...document.querySelectorAll('.js-footer-reviews-stars')];

        reviewsScoreElements.forEach(scoreEl => {
            scoreEl.innerText = scoreWithComma;
        });
        reviewsCountElements.forEach(countEl => {
            countEl.innerText = count;
        });

        stars.forEach(stars => {
            stars.innerHTML = getStars(score);
        });
    }
};

fetchReviews();
